import { SurtitleTagType } from './surtitle-tag-type';

export enum SurtitleTypeString {
  None = 'None',
  Soft = 'Soft',
  Topic = 'Topic',
  AssetClass = 'AssetClass',
  Sector = 'Sector',
  Company = 'Company',
  Fund = 'Fund',
  InvestmentTrust = 'InvestmentTrust',
  Manager = 'Manager',
  Person = 'Person',
  Share = 'Share',
}
